import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Text,
  FormLayout,
  TextField,
  InlineError,
  Select,
  Toast,
  PageActions,
  Loading,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const EditOnDemandSubscriber = () => {
  const navigate = useNavigate();
  const { id, subscriberId, bookingId } = useParams();
  const [isSaving, setIsSaving] = useState(true);
  const [item, setItem] = useState({
    status: "",
    start_date: "",
    expiry_date: "",
    freeze_date: "",
    resume_date: "",
  });

  const handleSelectChangeStatus = (newValue) => {
    setItem({ ...item, status: newValue });
  };
  const handleChangeStartDate = (newValue) => {
    setItem({ ...item, start_date: newValue });
  };
  const handleChangeExpiryDate = (newValue) => {
    setItem({ ...item, expiry_date: newValue });
  };
  const handleChangeFreezeDate = (newValue) => {
    setItem({ ...item, freeze_date: newValue });
  };
  const handleChangeResumeDate = (newValue) => {
    setItem({ ...item, resume_date: newValue });
  };

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const [error, setError] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      const response = await axios.get(
        `/on-demand-videos/${id}/subscribers/${subscriberId}/booking/${bookingId}`
      );
      const data = response?.data?.data;
      setItem({
        status: data?.status || "",
        start_date: data?.start_date
          ? data.start_date.split(" ")[0]
          : "",
        expiry_date: data?.expiry_date
          ? data.expiry_date.split(" ")[0]
          : "",
        freeze_date: data?.freeze_date
          ? data.freeze_date.split(" ")[0]
          : "",
        resume_date: data?.resume_date
          ? data.resume_date.split(" ")[0]
          : "",
      });
    } catch (err) {
      console.log(err);
    }
    setIsSaving(false);
  }

  return (
    <Page
      narrowWidth
      backAction={{
        onAction: () =>
          navigate(`/admin/on-demand-videos/${id}/subscribers`),
      }}
      title="Edit Subscriber"
    >
      {isSaving ? <Loading /> : null}

      <Card>
        <FormLayout>
          <Select
            label="Status"
            options={[
              { label: "Confirmed", value: "confirmed" },
              { label: "Cancelled", value: "cancelled" },
              {
                label: "Cancelled with no refund",
                value: "cancelled with no refund",
              },
            ]}
            onChange={handleSelectChangeStatus}
            value={item.status}
            placeholder="Please select"
          />
          <FormLayout.Group>
            <TextField
              label="Start Date"
              value={item.start_date}
              onChange={handleChangeStartDate}
              type="date"
            />
            <TextField
              label="Expiry Date"
              value={item.expiry_date}
              onChange={handleChangeExpiryDate}
              type="date"
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="Freeze Date"
              value={item.freeze_date}
              onChange={handleChangeFreezeDate}
              type="date"
            />
            <TextField
              label="Resume Date"
              value={item.resume_date}
              onChange={handleChangeResumeDate}
              type="date"
            />
          </FormLayout.Group>
          <InlineError message={error} />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );

  function handleSave() {
    setError("");
    setIsSaving(true);
    axios
      .post(`/on-demand-purchases/${bookingId}`, {
        status: item.status,
        ...(item.start_date && { start_date: item.start_date }),
        ...(item.expiry_date && { expiry_date: item.expiry_date }),
        ...(item.freeze_date && { freeze_date: item.freeze_date }),
        ...(item.resume_date && { resume_date: item.resume_date }),
      })
      .then((result) => {
        setIsSaving(false);
        toggleActive();
      })
      .catch((err) => {
        setError(err?.response?.data?.message || "An error occurred");
        setIsSaving(false);
      });
  }
};

export default EditOnDemandSubscriber;
